// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2NoRa","colMin":"styles_colMin__1rDhL","colCheckbox":"styles_colCheckbox__3vJG8"};